<template>
  <div class="edit-program-wrapper">
    <div
      class="edit-program g-edit-component"
      :class="ModalData.status == 2 ? 'program-linked' : {'program-active': computedProgramActive}"
    >
      <div class="edit-program__border">
        <div class="edit-program__top-bar">
          <div class="edit-program__top-bar__left">
            <div
              v-if="computedProgramType"
              class="edit-program__top-bar__program-type"
            >
              {{ computedProgramType.label }}
            </div>
          </div>
          <div class="edit-program__top-bar__right">
            <div class="edit-program__top-bar__weeks">
              <div class="">
                <span>
                  {{ this.$t('messages.programEdit.parameters.weekOf', {week: activeWeek }) }} {{ Math.ceil(computedWaterDays.length / 7) }}
                </span>
                <ol>
                  <li
                    v-for="week in (Math.ceil(computedWaterDays.length / 7))"
                    :key="week"
                    class="edit-program__top-bar__weeks__week"
                    :class="{'active': getActiveWeek(week, dayIndex + 1) === week }"
                  />
                </ol>
              </div>
            </div>
            <div
              id="twoButtonSwitch"
              class="edit-program__toggle"
              :class="{'active': !!parseInt(computedProgramActive)}"
            >
              <span>{{ computedProgramStatusText }}</span>
              <!-- eslint-disable  -->
              <div v-if="(ModalData.ID == 1 && store.data.controller.group === 'TWC')" id="threeButtonSwith" class="slidecontainer">
                <input type="range" min="0" max="2" step="1" v-model="value" class="slider" id="program1status" @click="ModalData.status = value">
              </div>
              <!-- eslint-enable  -->
              <div
                v-else
                class="g-btn g-btn--rounded g-btn--toggle"
                type="button"
                name="button"
                @click="ModalData.status = computedProgramActive === '1' ? '0' : '1'"
              />
            </div>
          </div>
        </div>

        <div class="edit-program__body">
          <slider-element
            v-bind="{ Data: {emitFunctionNamed: 'setDayIndex'}}"
            @setDayIndex="setDayIndex"
          >
            <div
              v-for="(day, index) in computedWaterDays"
              ref="day"
              :key="index"
              class="edit-program__body__day"
              :title="'Set irrigation this day to '+((day.selected)?'off':'on')"
              :class="{'active': index === dayIndex, 'watering': day.selected}"
              @click="dayClicked(day, index)"
            >
              <span
                class="edit-program__body__day__name"
                v-html="(!day.today)?day.name:'Today'"
              />
              <div class="edit-program__body__day__circle">
                <div
                  class="g-fancy-checkbox"
                  :class="{'g-fancy-checkbox--checked': day.selected}"
                >
                  <font-awesome-icon :icon="['fas', 'check']" />
                </div>
              </div>
            </div>
          </slider-element>
        </div>
      </div>
      <div class="edit-program__options">
        <select-element
          v-if="ModalData.capabilities.booster.enable && computedBoosterPumpList.length"
          :title="'Boosters'"
          :value="selectedBooster"
          :list="computedBoosterPumpList"
          :emit-function-named="'setBoosterPump'"
          @setBoosterPump="setBoosterPump"
        />

        
        <select-element
          :disabled="!ModalData.capabilities.allowPeriodChange"
          :title="'Period'"
          :value="ModalData.period"
          :list="computedPeriods"
          :emit-function-named="'setPeriod'"
          @setPeriod="setPeriod"
        />

        <range-element
          v-bind="{Data: waterBudgetData}"
          @setWaterBudget="setWaterBudget"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import RangeElement from '@/components/elements/RangeElement.vue'
import SliderElement from '@/components/elements/SliderElement.vue'
import SelectElement from '@/components/elements/SelectElementReactive.vue'
import $ from 'jquery'

export default {
  name: 'EditProgramParameters',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon,
    'range-element': RangeElement,
    'slider-element': SliderElement,
    'select-element': SelectElement
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store:
    {
      type: Object,
      default: function() {
        return{}
      }
    }    
  },
  data() {
    return{
      statusText: '',
      // Week Slider
      dayIndex: 0,
      activeWeek: 0,
      // Booster
      selectedBooster: this.ModalData.booster,
      // Days
      dayCodes: [{
        name: this.$tc('messages.sharedTexts.days.today', 1),
        code: 'To',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.monday', 1),
        code: 'M',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.tuesday', 1),
        code: 't',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.wednesday', 1),
        code: 'W',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.thursday', 1),
        code: 'T',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.friday', 1),
        code: 'F',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.saturday', 1),
        code: 's',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.sunday', 1),
        code: 'S',
        selected: false
      }, {
        name: this.$tc('messages.sharedTexts.days.watering', 1),
        code: '-',
        selected: false
      }],
      // WB
      waterBudgetData: {
        emitFunctionNamed: 'setWaterBudget',
        title: this.$t('messages.sharedTexts.waterBudget'),
        min: this.ModalData.capabilities.wb.minimum,
        max: this.ModalData.capabilities.wb.maximum,
        value: this.ModalData.waterBudget,
        type: 'flow',
        suffix: '%'
      },
      value: this.ModalData.status
    }
  },
  computed: {
    computedWaterDays() {
      const waterDays = this.ModalData.fullDaySchedule.split('')
      const days = this.ModalData.allDaysArranged.split('')

      return days.map((dayString, index) => Object.assign(
        {},
        this.dayCodes.find(dayCode => dayCode.code === dayString),
        {
          selected: waterDays[index] !== '-'
        })
      )
    },
    computedBoosterPumpList() {
      const boosters = Array(this.ModalData.capabilities.booster.count).fill().map((unused, index) => ({
        value: String(index + 1),
        label: String(index + 1)
      }))
      
      boosters.push({ value: 0, label: this.$t('messages.programEdit.parameters.none') })

      return boosters
    },
    computedProgramStatusText() {
      // console.log(this.store.data.controller.group)
        // if (this.ModalData.status == 2) {
        //   return('Linked')
        // } else {
      switch(this.computedProgramActive) {
        case "0":
          return(this.$t('messages.sharedTexts.status.passive'))
        case "1":
          return(this.$t('messages.sharedTexts.status.active'))
        case "2":
          return(this.$t('messages.sharedTexts.status.linked'))
        default:
          return('default')
      }

      // return(this.statusText)
      // return(this.computedProgramActive) ? this.$t('messages.sharedTexts.status.active') : this.$t('messages.sharedTexts.status.passive')
    },
    computedProgramActive() {
      return this.ModalData.status
    },
    computedProgramStatus() {
      $('#res').html(document.getElementById("program1status").value)
      return this.ModalData.status
    },
    computedProgramType() {
      const programTypes = JSON.parse(JSON.stringify(this.ModalData.capabilities.programTypes))
      const programType = programTypes.find(programType => programType.value === this.ModalData.irrigationType)

      if(programType)
        programType.label = this.$t(`messages.programEdit.setType.programs.${programType.label.toLowerCase()}.label`)

      return programType
    },
    computedPeriod() {
      return this.ModalData.period
    },
    computedPeriods() {
      return this.ModalData.capabilities.periods.map(period => Object.assign({}, period, {
        label: this.$t('messages.programEdit.parameters.schedule.' + period.label.toLowerCase().replace(' ', ''))
      }))
    }
  },
  watch: {
    computedPeriod(period) {
      this.SocketMessageSend({
        Category: 'Irrigation',
        Type: 'IrrPgmData',
        Oper: 'Upd',
        Seq: this.ModalData.ID,
        Period: period
      })
    },
    computedProgramActive(status) {
      this.SocketMessageSend({
        Category: 'Irrigation', Type: 'IrrPgmData', Oper: 'Upd',
        Seq: this.ModalData.ID, Status: status
      })
    }
  },
  methods: {
    dayClicked(day, index) {
      const period = this.computedPeriods.find(period => period.value === parseInt(this.ModalData.period))

      if(!period.editable) return false

      day.selected = !day.selected

      // console.info('index: ' + index + ' / day clicked: ' + JSON.stringify(day))
      let newWaterDays = this.computedWaterDays.map((day) => (day.selected) ? day.code : '-').join('')
      // console.info(newWaterDays + ' <- weekdays computed after click, sent to server')
      // console.info(this.ModalData.fullDaySchedule + ' <- this.ModalData.fullDaySchedule')

      this.SocketMessageSend({
        Category: 'Irrigation',
        Type: 'IrrPgmData',
        Oper: 'Upd',
        Seq: this.ModalData.ID,
        Period: period.value,
        Weekdays: this.computedWaterDays.map((day) => (day.selected) ? day.code : '-').join('')
      })

      this.ModalData.fullDaySchedule = newWaterDays
      // console.info(this.ModalData.fullDaySchedule + ' <- NEW this.ModalData.fullDaySchedule')

    },
    getActiveWeek(week, DayIndex) {
      const inRange = (x, min, max) => ((x - min) * (x - max) <= 0)
      const bool = inRange(DayIndex, ((week - 1) * 7) + 1, week * 7)

      if(bool) {
        this.activeWeek = week
        return week
      }
    },
    setDayIndex(Data) {
      this.dayIndex = Data

      if(this.DaySelected) this.DaySelected = this.computedWaterDays[Data]
    },
    setBoosterPump(newBooster, oldBooster) {
      this.SocketMessageSend({
        Category: 'Irrigation',
        Type: 'IrrPgmData',
        Oper: 'Upd',
        Seq: this.ModalData.ID,
        Booster: (newBooster.value === 'none') ? 0 : newBooster.value
      })
      this.ModalData.booster = newBooster
    },
    setWaterBudget(Data, event) {
      this.ModalData.waterBudget = this.SelectedWaterBudget = Data
      this.SocketMessageSend({
        Category: 'Irrigation', Type: 'IrrPgmData', Oper: 'Upd',
        Seq: this.ModalData.ID, Budget: Data,
      })
    },
    setPeriod(periodObj) {
      this.ModalData.period = String(periodObj.value)
    }
  }
}
</script>

<style lang="scss">
  // for generic range slider
  .slidecontainer {
    width: 100px;
  }

  .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 25px;
    border-radius: 30px;
    // background: #d3d3d3;
    outline: 2px;
    // opacity: 0.7;
    // -webkit-transition: .2s;
    // transition: opacity .2s;
  }

  .slider:hover {
    opacity: 1;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 33px;
    height: 35px;
    border-radius: 30px;
    background: #3565B0;
    cursor: pointer;
  }

  .slider::-moz-range-thumb {
    width: 35px;
    height: 35px;
    border-radius: 30px;
    background: #3565B0;
    cursor: pointer;
  }
  // ^^ generic range slider


  /*
    This first part makes sure the component aligns itself to layout
    even when not embedded in the edit component.
  */
  .edit-program-wrapper {
    margin: 0;
    position: relative;
    top: 50%;
    left: 50%;
    width: 80%;
    max-width: 1280px;
    transform: translate3d(-50%, -50%, 0);
    transition: al1s;

    .edit-container & {
      width: auto;
      position: static;
      transform: none;
    }
  }

  .edit-program {

    &__toggle {
      &.active span {
        transition: color 1s;
        transition-delay: 1s;
        color: $color-blue-marine;
      }
    }

    &__title {
      margin-top: 0;
      font-size: 14px;
      font-family: 'Montserrat-SemiBold';
      font-weight: normal;
    }

    &__border {
      background-color: $color-white;
      padding: 15px;
      border-top-left-radius: $application-base-border-radius;
      border-top-right-radius: $application-base-border-radius;
      box-shadow: 0px 4px 5px $color-grey;
      transform: translateZ(0); // New layout context for z-index
    }

    // top bar
    &__top-bar {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      flex-wrap: wrap;

      * {
        flex: 0 1 auto;
      }

      &__left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        > *:first-child {
          margin-right: 20px;
        }
      }

      &__right {
        display: flex;
        > *:first-child {
          margin-right: 20px;
        }
      }

      &__weeks {
        display: flex;
        align-items: center;
        text-align: center;
        font-size: 13px;

        &__week {
          display: inline-block;
          width: 20px;
          height: 7px;
          margin-right: 2px;
          border-radius: 1.25em;
          background-color: $color-white;
          border: 1px solid $color-green-ok;

          &:last-child {
            margin-right: 0;
          }

          &.active {
            background-color: $color-green-ok;
          }
        }
      }
    }

    // body
    &__body {
      display: flex;
      align-items: stretch;

      > * {
        flex: 0 1 auto;
      }

      * {
        user-select: none;
      }

      .slider-element {
        .slider-element__arrow,
        .slider-element__elements-wrapper {
          background-color: $color-program-passive;
          transition: background-color 1s;
          .slider-element__arrow:before {
            background-color: darken($color-program-passive, 10);
          }
        }

        .program-active & {
          .slider-element__arrow,
          .slider-element__elements-wrapper {
            background-color: $color-program-active;
          }
          .slider-element__arrow:before {
            background-color: darken($color-program-active, 10);
          }
        }

        .program-linked & {
          .slider-element__arrow,
          .slider-element__elements-wrapper {
            background-color: $color-program-linked;
          }
          .slider-element__arrow:before {
            background-color: darken($color-program-linked, 10);
          }
        }        
      }

      &__intelligence-wrapper {
        position: relative;
        left: 6px;
      }
      &__intelligence-levels {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        opacity: 0.2;

        > * {
          flex: 0 1 auto;
        }
      }
      &__intelligence-level {
        flex: 0 1 auto;
        box-sizing: border-box;
        width: 70px;
        height: 100%;
        margin-bottom: 2px;
        background: $color-grey;
        background-position: 12px center;
        background-repeat: no-repeat;
        background-size: 40px;

        &--weather {
          background-image: url('~@graphics/intelligence-levels/addons_weather.svg');
        }
        &--wind {
          background-image: url('~@graphics/intelligence-levels/addons_wind.svg');
        }
        &--et-auto {
          background-image: url('~@graphics/intelligence-levels/addons_ET.svg');
        }
        &--sensor {
          background-image: url('~@graphics/intelligence-levels/addons_sensor.svg');
        }

        &:first-child {
          border-top-left-radius: $application-base-border-radius;
        }

        &:last-child {
          border-bottom-left-radius: $application-base-border-radius;
          margin-bottom: 0;
        }

        &.active {
          background-color: $color-green-ok;
          color: $color-white;
        }
      }

      &__days-wrapper {
        width: 100%;
        background-color: darken($color-white, 5);
        border-top: 1px solid $color-grey-dark;
        border-bottom: 1px solid $color-grey-dark;
        overflow: hidden;
      }
      &__days {
        @include hardware-accelerate(true);
        width: auto;
        display: inline-block;
        white-space: nowrap;
        transition: transform 1s;
      }
      &__day {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        width: 110px;
        padding: 10px;
        margin: 5px;
        text-align: center;
        font-family: $font-primary-semibold;
        color: $color-grey-dark;
        cursor: pointer;

        &:nth-child(7n):after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          right: -5px;
          width: 1px;
          border-right: 1px solid $color-grey;
        }

        &:last-child:after {
          content: '';
        }

        &__name {
          .program-active & {
            color: darken($color-program-active, 45);
          }
          .program-linked & {
            color: darken($color-program-linked, 45);
          }
          .active & {
            color: lighten($color-grey-darker, 15);
            transition: color 0.4s;

            .program-active & {
              color: darken($color-program-active, 65);
            }
            
            .program-linked & {
              color: darken($color-program-linked, 65);
            }
          }

        }

        &__circle {
          position: relative;
          background: url('~@graphics/day-inactive.svg');
          background-size: 160%;
          background-position: center center;
          box-shadow: 0px 0px 5px -2px $color-black;
          // hack to make proportional circle
          height: 0;
          padding-bottom: 100%;
          width: 100%;
          // hack end
          margin-top: 20px;
          border-radius: 50%;
          transform: scale(0.87);
          transition: all 0.5s;

          .g-fancy-checkbox {
            position: absolute;
            top: 50%;
            left: 50%;
            padding: 15px;
            transform: translate3d(-50%, -50%, 0);
            border-radius: 50%;
            background: lighten($color-grey, 15);
            border-width: 1px;
            border: 2px solid #030405;

            &--checked {
              color: $color-grey-darker;
            }
          }

          .watering & {
            background: url('~@graphics/day.svg');
            background-size: 160%;
            background-position: center center;
            transform: scale(1);
          }
        }
      }
      &__text {
        font-size: 14px;
        margin: 5px 10px;
      }
    }

    &__options {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 15px;
      background: $color-white-gradient;
      border-bottom-left-radius: $application-base-border-radius;
      border-bottom-right-radius: $application-base-border-radius;

      > * {
        margin: 0 20px 0 0;
      }

      .select-element-wrapper {
        margin: 10px 0px;
      }

      .slider-element-wrapper {
        padding: 0px 0 21px;

        .slider-element {
          margin-top: 7px;
        }
      }
      .range-element {
        margin: 0;
      }
      .range-element__slider {
        margin-left: 0;
      }
    }
  }
</style>
